<template>
  <BaseField
    ref="field"
    v-bind="attributes"
    v-on="$listeners"
  />
</template>

<script>
import BaseField from '@/components/BaseField.vue';

export default {
  name: 'FieldMeter',
  inheritAttrs: false,
  components: {
    BaseField,
  },
  props: {
    min: {
      type: Number,
      default: 0,
    },
    scale: {
      type: Number,
      default: 2,
    },
  },
  staticData: (vm) => ({
    mask: {
      mask: Number,
      scale: vm.scale,
      normalizeZeros: true,
      radix: '.',
      mapToRadix: [','],
    },
  }),
  computed: {
    attributes() {
      return {
        type: 'tel',
        label: this.$t('fields.meterLabel'),
        errorMessage: this.$t('fields.meterError'),
        placeholder: this.$t('fields.meterPlaceholder'),
        maskOptions: this.mask,
        completeValidator: this.checkMinValue,
        ...this.$attrs,
      };
    },
  },
  methods: {
    focus() {
      return this.$refs.field?.focus();
    },
    checkValidity() {
      return this.$refs.field?.checkValidity();
    },
    checkHasValue() {
      return this.$refs.field?.checkHasValue();
    },
    checkMinValue() {
      return Number(this.$attrs.value) >= this.min;
    },
  },
};
</script>
